module.exports = __webpack_public_path__ + "static/logo-align-right-c15ad9aab379e0dc7c61f1deb0c2055e.png";